package com.partejar.app.core.navigation

import com.partejar.app.core.ui.components.PartejarDockDestination

internal fun PartejarDockDestination.appRoute(): String? = when (this) {
    PartejarDockDestination.HOME -> AppRoutes.HOME
    PartejarDockDestination.GESTANTES -> AppRoutes.GESTANTES
    PartejarDockDestination.RELACIONAMENTOS -> AppRoutes.RELACIONAMENTOS
    PartejarDockDestination.CONFIGURACOES -> AppRoutes.SETTINGS
    PartejarDockDestination.AGENDA -> AppRoutes.AGENDA
}
